module.exports = __webpack_public_path__ + "static/media/有沒有去其他地方暫住幾天.5f5ecf36.png";